/**
 * Redux reducer for key shortcuts.
 * @module redux/reducers/keyShortcuts
 */

import { SET_MODIFIER_STATE } from '../actions/keyShortcuts';

const initialState = {
  isModifierActive: false,
  modifierKeyCode: 18,
  shortcuts: {
    nextPage: ['pageup'],
    prevPage: ['pagedown'],
    openBrowseTemplates: ['alt+t'],
    openBrowseContent: ['alt+c'],
    openGraphicTemplates: ['alt+g'],
    openCompletedGraphics: ['alt+r'],
    openAutomation: ['alt+a'],
    openStudioClips: ['alt+l'],
    openImagesContent: ['alt+i'],
    openMoviesContent: ['alt+m'],
    openDataContent: ['alt+d'],
    openRundowns: ['alt+o'],
    openContextCombo: ['alt+n'],
    openCategoryCombo: ['alt+e'],
    openFilterCombo: ['alt+f'],
    focusSearchBar: ['alt+s'],
    focusToEdit: ['alt+e'],
    insert: ['alt+i'],
    preview: ['alt+p'],
    publish: ['alt+b'],
    modify: ['alt+m'],
    saveImage: ['alt+a'],
    changeTemplate: ['alt+g'],
    closeEdit: ['alt+x'],
    openChannelCombo: ['alt+h'],
    focusTimecode: ['alt+d'],
    focusSlug: ['alt+l'],
    openCompose: ['alt+p'],
    openOrder: ['alt+r']
  }
};

const ACTION_HANDLERS = {
  [SET_MODIFIER_STATE]: (state, action) => ({
    ...state,
    isModifierActive: action.payload.active
  })
};

export default function app(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./app/reducers/keyShortcuts.js